import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <Seo title="页面不存在 - 唐心" description="抱歉，你访问的页面不存在。" />
      <div className="w-full px-4 md:px-6 py-16">
        <div className="flex flex-col items-center justify-center rounded-xl bg-background-100 py-20 ring-1 ring-background-200">
          <span className="font-label text-7xl font-bold text-primary-200 md:text-9xl">
            404
          </span>
          <p className="mt-6 text-lg font-medium text-foreground-800">
            这个页面走失在了片场
          </p>
          <p className="mt-2 font-label text-sm text-foreground-400">
            {location.pathname}
          </p>
          <Link
            to="/"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-700 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}